<div *ngIf="showSearch" class="a-search-container a-sub-frame">
  <!--Not use the filter inside local-search any more-->
  <local-search [label]="searchLabel" [items]="null" [searchKeys]="searchKeys" [performance]="performance"
    [placeholder]="searchPlaceholder" [style]="{width:'100%'}" filter="contains" (onSearch)="onSearch($event)">
  </local-search>
</div>
<div class="a-loc-nav-title flex-wrapper center-items" [ngClass]="headerClass"
  *ngIf="showTitle || (showCheckAll && multiple)">
  <mat-checkbox class="a-checkbox"
    [disabled]="disabled || (maxSelectionLength >0 && filteredItems.length > maxSelectionLength)" [checked]="checkedAll"
    *ngIf="showCheckAll && multiple" (change)="checkAllChanged($event)"></mat-checkbox>
  <span class="heading-2 pl-4">{{title || 'Select ' + filteredItems.length + ' item(s)'}}</span>
</div>
<mat-selection-list #list *ngIf="virtualScroll && selectable" (selectionChange)="onSelectionChange($event)"
  [multiple]="multiple" [ngClass]="navClass">
  <virtual-scroller *ngIf="virtualScroll" #scroll [items]="filteredItems" [ngClass]="scrollerClass"
    [@listAnimation]="scroll.viewPortItems?.length" [style.height]="scrollHeight" [scrollAnimationTime]="50">
    <mat-list-option [disabled]="disabled" *ngFor="let item of scroll.viewPortItems" [value]="item"
      [ngClass]="itemClass + (disabled?' disabled':'')" [selected]="isSelected(item)"
      [checkboxPosition]="checkboxPosition">
      <ng-container *ngIf="itemTemplate; else plainItem">
        <ng-template *ngTemplateOutlet="itemTemplate; context: { $implicit : item,selected:isSelected(item)  }">
        </ng-template>
      </ng-container>
      <ng-template #plainItem>
        <div class="plain">{{nameField?item[nameField]:item}}</div>
      </ng-template>
    </mat-list-option>
  </virtual-scroller>
</mat-selection-list>
<!--Mat List has poor performance without virtual scroll-->
<ul class="a-loc-nav" [ngClass]="navClass" *ngIf="!virtualScroll && selectable" [@listAnimation]="filteredItems.length">
  <li *ngFor="let item of filteredItems" class="a-list-item" [ngClass]="itemClass"
    [class.filtered]="item.filtered && performance" [class.visible]="!item.filtered || !performance"
    (click)="itemClick(item)" [class.mat-list-single-selected-option]="item==selectedItem">
    <ng-container *ngIf="itemTemplate; else plainItem">
      <ng-template *ngTemplateOutlet="itemTemplate; context: { $implicit : item }"></ng-template>
    </ng-container>
    <ng-template #plainItem>
      <div>{{nameField?item[nameField]:item}}</div>
    </ng-template>
  </li>
</ul>
<mat-list *ngIf="!selectable" [ngClass]="navClass">
  <!-- Doesn't support multile-line -->
  <!-- <cdk-virtual-scroll-viewport [style.height]="scrollHeight" [itemSize]="itemSize"
    [minBufferPx]="minBufferPx" [maxBufferPx]="maxBufferPx">
    <ng-container
      *cdkVirtualFor="let item of filteredItems; let firstChild=first; let lastChild=last; let index=index; trackBy: trackBy">
      <ng-container *ngIf="itemTemplate; else plainItem">
        <div class="list-item a-nav-item" [ngClass]="itemClass">
          <ng-template *ngTemplateOutlet="itemTemplate; context: { $implicit : item }"></ng-template>
        </div>
      </ng-container>
      <ng-template #plainItem>
        <mat-list-item [ngClass]="itemClass">
          <div class="plain">{{nameField?item[nameField]:item}}</div>
        </mat-list-item>
      </ng-template>
    </ng-container>
  </cdk-virtual-scroll-viewport> -->

  <virtual-scroller *ngIf="virtualScroll" #scroll1 [items]="filteredItems" [ngClass]="scrollerClass"
    [@listAnimation]="scroll1.viewPortItems?.length" [style.height]="scrollHeight" [scrollAnimationTime]="50">
    <ng-container *ngFor="let item of scroll1.viewPortItems">
      <ng-container *ngIf="itemTemplate; else plainItem">
        <div class="list-item a-nav-item" [ngClass]="itemClass">
          <ng-template *ngTemplateOutlet="itemTemplate; context: { $implicit : item }"></ng-template>
        </div>
      </ng-container>
      <ng-template #plainItem>
        <mat-list-item [ngClass]="itemClass">
          <div class="plain">{{nameField?item[nameField]:item}}</div>
        </mat-list-item>
      </ng-template>
    </ng-container>

  </virtual-scroller>
</mat-list>
<ng-content></ng-content>
